import React, { useState, Fragment } from 'react';
// Context
import { useCTALogsData } from '../../../../context/CTALogsContext';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ShowMoreText from 'react-show-more-text';
// Components
import DefaultTable from '../../../../components/table/DefaultTable';
import { Column } from '../../../../components/table/components/Types';
import DefaultModal from '../../../../components/modal/DefaultModal';
import CTALogForm from './CTALogForm';
import DefaultTooltip from '../../../../components/tooltip/DefaultTooltip';
// Utils
import { ApplicationOptions, CTALogStatusOptions } from '../../../../utils/Enums';
// Icons
import { FaPlus } from 'react-icons/fa6';
import { FaPencilAlt } from 'react-icons/fa';
// Styles
import { styleAppCell } from '../../styles/styles';

const CTALogsTable = () => {
  // Context
  const { state, dispatch } = useCTALogsData();

  // State
  const [showModal, setModalShow] = useState(false);
  const [CTALog, setCTALog] = useState(null);

  // Methods
  const handleShowModal = () => setModalShow(true);

  const handleCloseModal = () => setModalShow(false);

  const handleEditCTALog = (item) => {
    setCTALog(item);
    handleShowModal();
  };

  const handleCreateCTALog = () => {
    setCTALog(null);
    handleShowModal();
  };

  const handleSort = (accessor) => {
    dispatch({
      type: 'SET_SORT',
      payload: {
        type: !state.sort.type || state.sort.type === 'desc' ? 'asc' : 'desc',
        accessor: accessor,
      },
    });
  };

  return (
    <>
      <Row className="my-3">
        <Col className="cta--table-title">
          <h6>Tipos</h6>
        </Col>
        <Col className="text-end">
          <Button onClick={handleCreateCTALog}>
            <FaPlus /> Tipo de CTA
          </Button>
        </Col>
      </Row>
      <DefaultTable data={state.data} isLoading={state.loading}>
        <Column
          header={'ID'}
          accessor="id"
          headerClass={'width-1 text-nowrap'}
          sorting={{ sort: state.sort, apply: handleSort }}
          render={(value, row) => {
            const statusOption = CTALogStatusOptions.find((option) => option.id === row.statusId);
            return (
              <DefaultTooltip text={statusOption.name}>
                <div className="d-flex justify-content-start align-items-center">
                  <div className={`${statusOption.id === 1 ? 'cta--status-active' : ''} cta--status`}></div>
                  <div>{value}</div>
                </div>
              </DefaultTooltip>
            );
          }}
        />
        <Column
          header={'Nome'}
          accessor="name"
          headerClass={'width-1'}
          cellClassName={'text-nowrap'}
          sorting={{ sort: state.sort, apply: handleSort }}
        />
        <Column
          header={'Tipo'}
          accessor="typeInfo.name"
          headerClass={'width-1'}
          cellClassName={'text-nowrap'}
          sorting={{ sort: state.sort, apply: handleSort }}
        />
        <Column
          header={'Classe'}
          accessor="classInfo"
          headerClass={'width-1'}
          render={(value, row) => {
            const applicationOption = ApplicationOptions.find((option) => option.id === value.applicationId);
            return (
              <span className="cta--cell-app">
                {applicationOption ? (
                  <>
                    <span className={styleAppCell(applicationOption.name)}>{applicationOption.name}</span>
                    <span className="ms-1">{value.name}</span>
                  </>
                ) : (
                  ''
                )}
              </span>
            );
          }}
        />
        <Column
          header={'Observações'}
          accessor="obs"
          render={(value) => {
            return (
              <ShowMoreText lines={1} more={'ler mais'} less={'ler menos'}>
                {value &&
                  value.split('\n').map((item, key) => {
                    return (
                      <Fragment key={key}>
                        {item}
                        <br />
                      </Fragment>
                    );
                  })}
              </ShowMoreText>
            );
          }}
        />
        <Column
          header={'Ações'}
          headerClass={'width-1'}
          render={(value, row) => {
            return (
              <div className="table--action">
                <span onClick={() => handleEditCTALog(row)}>
                  <FaPencilAlt />
                </span>
              </div>
            );
          }}
        />
      </DefaultTable>
      <DefaultModal
        title={CTALog && CTALog.id !== 0 ? 'Editar tipo de CTA' : 'Novo tipo de CTA'}
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      >
        <CTALogForm CTALog={CTALog} handleCloseModal={handleCloseModal} />
      </DefaultModal>
    </>
  );
};

export default CTALogsTable;
